import React from 'react'
import { SvgIcon } from './SvgIcon'

interface Props {
  className?: string
}

export function Bonus({ className }: Props) {
  return (
    <SvgIcon className={className} viewBox="0 0 16 16" fill="currentColor">
      <path d="M11.29,5.16a4.84,4.84,0,0,0,.91-.83c1.39-1.67.87-3.09,0-3.81-.41-.34-1.9-1.31-3.65.79A6.24,6.24,0,0,0,8,2.18a6.24,6.24,0,0,0-.56-.87C5.69-.79,4.2.18,3.79.52c-.86.72-1.38,2.14,0,3.81h0a4.84,4.84,0,0,0,.91.83H0V9H7.36V5.16H8.64V9H16V5.16ZM5,3.31H5c-.85-1-.38-1.43-.22-1.56s.54-.45,1.4.58a5.29,5.29,0,0,1,1,2.29A5.1,5.1,0,0,1,5,3.31Zm5.94,0A5.1,5.1,0,0,1,8.83,4.62a5.29,5.29,0,0,1,1-2.29c.49-.57.82-.73,1-.73a.53.53,0,0,1,.36.15c.16.13.63.53-.22,1.56Z" />
      <rect x="0.8" y="10.24" width="6.56" height="5.76" />
      <rect x="8.64" y="10.24" width="6.56" height="5.76" />
    </SvgIcon>
  )
}
